import { useEffect, useState } from "react";
import { Layout, Page, Spinner } from "@shopify/polaris";
import { SubscriptionPlan } from "@prisma/client";

import PlanCards from "./components/PlanCards/PlanCards.jsx";
import { useAppQuery } from "../../hooks/index.js";
import { SUBSCRIPTION_PLAN_ENTERPRISE } from "../../../constants/subscriptionPlans.js";
import { makeId } from "../../utils/makeId.js";
import SwitchingPlanModal from "../modals/SwitchingPlanModal/SwitchingPlanModal.js";
import { useAppSelector } from "../../hooks/redux.js";
import styles from "./BillingComponent.module.css";

const enterprisePlan = {
  id: makeId(20),
  name: SUBSCRIPTION_PLAN_ENTERPRISE,
  productsLimit: 100000,
  collectionsLimit: 5000,
  monthlyPrice: null,
  yearlyPricePerMo: null,
  crossedPrice: null,
};

export interface ISubscriptionPlans {
  customPlan: SubscriptionPlan | null,
  defaultSubscriptionPlans: SubscriptionPlan[]
}

const BillingComponent = () => {
  const appSettings = useAppSelector((state) => state.shop?.data?.appSettings);
  const [plans, setPlans] = useState([]);

  const { isLoading: isGetPlansLoading, data } = useAppQuery<ISubscriptionPlans, Error>({
    url: "/api/app-subscription/plans",
    reactQueryOptions: {},
    fetchInit: {}
  });

  useEffect(() => {
    if (data?.defaultSubscriptionPlans) {
      setPlans(() => [
        ...data.defaultSubscriptionPlans,
        data?.customPlan ? { ...data?.customPlan, isCustom: true } : enterprisePlan
      ]);
    }
  }, [data, appSettings]);

  return (
    <Page
      fullWidth
      title="Pick your plan"
      additionalMetadata={
        <p className={styles["additionalMetadata"]}>
          Boost your profitability with
          Stockhide! Our Shopify App optimizes your store by managing out-of-stock products effectively. Explore our
          competitive pricing plans to increase profits today.
        </p>
      }
    >

      {
        isGetPlansLoading ? (
          <Spinner size="large" />
        ) : (
          <Layout>
            <Layout.Section>
              <PlanCards plans={plans} />
            </Layout.Section>
            <Layout.Section>
              <p className={styles["rulesInfo"]}>
                * Your plan allows you to reach up to your limit of products and collections. For example, if you'd like
                to use our App on 5 collections that contain 10 products each: you'd be using our app on 50 products and
                would need to be on our <ins>STARTER</ins> plan because 50 products is larger than the 25 products limit of
                our <ins>BASIC</ins> plan.
              </p>
            </Layout.Section>
            <SwitchingPlanModal />
          </Layout>
        )}
    </Page>
  );
};

export default BillingComponent;